<!-- <div #mapViewNode class="inventeringsrutor__esri-map">
  <div class="loading-mask" *ngIf="isLoading">
    <app-loader class="karta-loader"></app-loader>
  </div>
</div> -->
<app-resultat-karta-base #mapComponent [maxScaleValue]="500000"></app-resultat-karta-base>
<br />
<ui-figure-caption>
    <ui-figure-text ui-figure-text-bold>
        <ng-container *ngIf="(inventeringsNiva$ | async) === 'HelaLandet' || (inventeringsNiva$ | async) === 'Landsdel'; else longTextTemplate">
            Kartan visar den geografiska avgränsning som rapporten gäller för. Det stickprov av slumpmässigt placerade kilometerrutor som ingår i inventeringen
            visas endast på läns- och ÄFO-nivå. Bakgrundskarta © Lantmäteriet
        </ng-container>

        <ng-template #longTextTemplate>
            Kartan visar den geografiska avgränsning som rapporten gäller för och det stickprov av slumpmässigt placerade kilometerrutor som ingår i
            inventeringen. Blå rutor (<span class="color-legend color-legend-blue"></span>) ingick i den senaste inventeringen medan de gröna rutorna (<span
                class="color-legend color-legend-green"
            ></span
            >) visar tidigare två inventeringar. I kartan har rutans exakta position dolts genom en slumpmässig förskjutning, vilket kan göra att enstaka rutor
            verkar ligga utanför området. Bakgrundskarta © Lantmäteriet
        </ng-template>
    </ui-figure-text>
</ui-figure-caption>
